import { render, staticRenderFns } from "./back-attachment-printing.vue?vue&type=template&id=608dd1e3&"
import script from "./back-attachment-printing.vue?vue&type=script&lang=ts&"
export * from "./back-attachment-printing.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports